import {SortDirection} from 'app/models/sort-direction.enum';
import {AssetSortingType} from 'app/models/asset-sorting-type';
import {Source} from 'app/models/source.enum'
import {FileSorting} from 'app/models/file-sorting.enum';
import {IAsset} from 'app/models/asset.interface'
import {GoogleTagManagerService} from './google-tag-manager.service';
export abstract class SortingArrayUtitlity {
    sort: AssetSortingType;
    direction: SortDirection;
    asset: IAsset;//Lets avoid stupid any
    assetType: Source;
    SortName = FileSorting;
    Direction = SortDirection;
    constructor(private gtmService: GoogleTagManagerService) {}

    onColumnSort(sort: AssetSortingType): void {
        if (typeof this.sort !== 'undefined') {
          // Changed until new tag plan resolvement
          this.gtmService.pushEvent(`Sort by - ${sort.name}`);
        }
        if (this.sort !== sort) {
            this.sort = sort;
            this.direction = SortDirection.Ascending;
        } else {
            this.direction = this.direction === SortDirection.Descending
                ? SortDirection.Ascending
                : SortDirection.Descending;
        }
        this.asset.files.sort((a, b) => {
            if (sort == null) {
                return 0;
            } else {
                let result = 0;
                switch (sort.id) {
                    case FileSorting.NameAsc:
                        result = a.displayName.localeCompare(b.displayName);
                        break;
                    case FileSorting.NameDesc:
                        result = b.displayName.localeCompare(a.displayName);
                        break;
                    case FileSorting.TimeCreated:
                        result = a.createdTime < b.createdTime ? 1 : (a.createdTime > b.createdTime ? -1 : 0);
                        break;
                }
                return this.direction === SortDirection.Descending ? result * -1 : result;
            }
        })

    }

}




// WEBPACK FOOTER //
// ./src/app/services/utility.service.ts